<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'users.updateUser.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button mat-icon-button mat-dialog-close aria-label="Close Dialog"><mat-icon>close</mat-icon></button>
    </div>
  </div>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="userDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="row">
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.fname' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <input type="text" maxlength="31" class="form-control" formControlName="firstName" (keydown.space)="$event.preventDefault()">
                <div *ngIf="f.firstName.invalid && (f.firstName.dirty ||
                  f.firstName.touched)" class="alert alert-danger">
                  <div *ngIf="f.firstName.errors?.required">{{'users.updateUser.fnameError1' | translate}}</div>
                  <div *ngIf="f.firstName.errors?.minlength">{{'users.updateUser.fnameError2' | translate}}</div>
                  <div *ngIf="f.firstName.errors?.maxlength">{{'users.updateUser.fnameError3' | translate}}</div>
                  <div *ngIf="f.firstName.errors?.pattern">{{'users.updateUser.fnameError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.lname' | translate}}</label><span class="required">*</span>
              </div>

              <div class="input-field">
                <input type="text" maxlength="31" class="form-control" formControlName="lastName" (keydown.space)="$event.preventDefault()">
                <div *ngIf="f.lastName.invalid && (f.lastName.dirty ||
                  f.lastName.touched)" class="alert alert-danger">
                  <div *ngIf="f.lastName.errors?.required">{{'users.updateUser.lnameError1' | translate}}</div>
                  <div *ngIf="f.lastName.errors?.minlength">{{'users.updateUser.lnameError2' | translate}}</div>
                  <div *ngIf="f.lastName.errors?.maxlength">{{'users.updateUser.lnameError3' | translate}}</div>
                  <div *ngIf="f.lastName.errors?.pattern">{{'users.updateUser.lnameError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.phone' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <input type="text" maxlength="25" class="form-control" formControlName="phone" (keydown)="onKeydown($event)"
                  onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()"
                  (blur)="onClickOutside(true)" (click)="onClickOutside(false)">
                <div *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" class="alert alert-danger">
                  <div *ngIf="f.phone.errors?.required">{{'users.updateUser.phoneError1' | translate}}</div>
                  <div *ngIf="f.phone.errors?.minlength">{{'users.updateUser.phoneError2' | translate}}</div>
                  <div *ngIf="f.phone.errors?.maxlength">{{'users.updateUser.phoneError3' | translate}}</div>
                  <div *ngIf="f.phone.errors?.pattern?.requiredPattern">{{'users.updateUser.phoneError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.email' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <input type="email" maxlength="125" class="form-control" formControlName="emailId" (keydown)="changeField($event)"
                  (keydown.space)="$event.preventDefault()" readonly>
                <div class="col-md-12" *ngIf="f.emailId.invalid &&
                    (f.emailId.touched || f.emailId.dirty)" class="alert
                    alert-danger">
                  <div *ngIf="f.emailId.errors?.required">{{'users.updateUser.emailError1' | translate}}</div>
                  <div *ngIf="f.emailId.errors?.minlength">{{'users.updateUser.emailError2' | translate}}</div>
                  <div *ngIf="f.emailId.errors?.maxlength">{{'users.updateUser.emailError3' | translate}}</div>
                  <div *ngIf="f.emailId.errors?.pattern">{{'users.updateUser.emailError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.speciality' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <input type="text" maxlength="101" class="form-control" formControlName="speciality">
                <div *ngIf="f.speciality.invalid && (f.speciality.dirty || f.speciality.touched)" class="alert alert-danger">
                  <div *ngIf="f.speciality.errors?.required">{{'users.updateUser.specialityError1' | translate}}</div>
                  <div *ngIf="f.speciality.errors?.minlength">{{'users.updateUser.specialityError2' | translate}}</div>
                  <div *ngIf="f.speciality.errors?.maxlength">{{'users.updateUser.specialityError3' | translate}}</div>
                  <div *ngIf="f.speciality.errors?.pattern">{{'users.updateUser.specialityError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'users.updateUser.center' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <input type="text" maxlength="101" class="form-control" formControlName="center">
                <div *ngIf="f.center.invalid && (f.center.dirty || f.center.touched)" class="alert alert-danger">
                  <div *ngIf="f.center.errors?.required">{{'users.updateUser.centerError1' | translate}}</div>
                  <div *ngIf="f.center.errors?.minlength">{{'users.updateUser.centerError2' | translate}}</div>
                  <div *ngIf="f.center.errors?.maxlength">{{'users.updateUser.centerError3' | translate}}</div>
                  <div *ngIf="f.center.errors?.pattern">{{'users.updateUser.centerError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row input-wrapper">
          <div class="col-md-6 input-field">
            <div class="input-label">
              <label>{{'users.updateUser.status.option1' | translate}}</label><span class="required">*</span>
            </div>
            <div class="input-field">
              <select aria-placeholder="Status" class="form-control
                  ng-untouched ng-pristine ng-valid" ng-reflect-model="" formControlName="status">
                <option value="" ng-reflect-value="">
                  {{'users.updateUser.status.option1' | translate}}</option>
                  <option *ngFor="let statusList of statusList" value="{{ statusList.id == 1 ? true : false}}">
                    {{ statusList.title }}
                  </option>
              </select>
              <div *ngIf="f.status.invalid && (f.status.dirty ||
                  f.status.touched)" class="alert alert-danger">
                <div *ngIf="f.status.errors?.required">{{'users.createUser.statusError1' | translate}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="collectionWithRoles.length!==0 && assignedRole == 'Account Admin'">
        <label class="role-label">{{'users.updateUser.labelRole' | translate}}</label>
        <!-- <table class="table table-bordered" formArrayName="roles">
          <thead>
            <tr>
              <th class=" text-center fw-normal bg">
                {{'users.updateUser.roleTable.column1' | translate}}</th>
              <th colspan="4" class="text-center fw-normal bg">
                {{'users.updateUser.roleTable.column2' | translate}}</th>
            </tr>
          </thead>
          <tbody *ngIf="userDetailsForm.controls['roles']&&userDetailsForm.controls['roles']['controls'] ">
            <tr *ngFor="let r of userDetailsForm.controls['roles']['controls']; let
                i=index" class="grid-container " [formGroupName]="i" class="border-1">
              <td class="text-center fw-normal t-border">
                <ng-container *ngIf="r.get('collectionname').value?.length > 30 then sliceTitle else noSliceTitle">
                </ng-container>

                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{r.get('collectionname').value}}" matTooltipPosition="above">
                    {{r.get('collectionname').value | slice: 0:30}}...</div>
                </ng-template>
                <ng-template #noSliceTitle>
                  <div class="text-bold">{{r.get('collectionname').value }}</div>
                </ng-template>
              </td>
              <div *ngFor="let role of r.get('roleid')['controls'];
                    let j=index">
                <td [formGroupName]="j">
                    <input type="checkbox"  formControlName="selected" >
                    <ng-container *ngIf="role.get('rolename').value?.length > 40 then sliceTitle else noSliceTitle">
                    </ng-container>

                    <ng-template #sliceTitle>
                      <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{role.get('rolename').value}}" matTooltipPosition="above">
                        {{role.get('rolename').value | slice: 0:30}}...</div>
                    </ng-template>
                    <ng-template #noSliceTitle>
                      <div class="text-bold">{{role.get('rolename').value }}</div>
                    </ng-template>


                </td>
              </div>
            </tr>
          </tbody>
        </table> -->

        <table class="table table-bordered" formArrayName="roles">
          <thead>
            <tr>
              <th class=" text-center fw-normal bg">
                {{'users.updateUser.roleTable.column1' | translate}}</th>
              <th colspan="4" class="text-center fw-normal bg">
                {{'users.updateUser.roleTable.column2' | translate}}</th>
            </tr>
          </thead>
          <tbody *ngIf="userDetailsForm.controls['roles']&&userDetailsForm.controls['roles']['controls'] ">
            <tr *ngFor="let r of userDetailsForm.controls['roles']['controls']; let
                i=index" class="grid-container " [formGroupName]="i" class="border-1">
              <td class="text-center fw-normal t-border">
                <ng-container *ngIf="r.get('collectionname').value?.length > 30 then sliceTitle else noSliceTitle">
                </ng-container>

                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{r.get('collectionname').value}}" matTooltipPosition="above">
                    {{r.get('collectionname').value | slice: 0:30}}...</div>
                </ng-template>
                <ng-template #noSliceTitle>
                  <div class="text-bold">{{r.get('collectionname').value }}</div>
                </ng-template>
              </td>
              <div class=" wrapper d-flex flex-wrap" formArrayName="roleid">
                <div [ngClass]="{'w-100' :r.get('roleid')['controls'].length === 1 || r.get('roleid')['controls'].length === 0, 'w-50':r.get('roleid')['controls'].length === 2,
                  'col-33-33':r.get('roleid')['controls'].length === 3, 'w-25':r.get('roleid')['controls'].length >= 4}" class="t-border" *ngFor="let role of
                    r.get('roleid')['controls'];
                    let j=index">
                  <td class="padding" [formGroupName]="j">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="form-check-input text-center" formControlName="selected" [ngClass]="{'disabled': (role.get('rolename').value == accountAdmin && role.get('selected').value == true || assignedRole == 'Doctor')}">
                      <p class="text-center-role" for="customCheck1">
                        <ng-container *ngIf="role.get('rolename').value?.length > 40 then sliceTitle else noSliceTitle">
                        </ng-container>

                        <ng-template #sliceTitle>
                          <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{role.get('rolename').value}}" matTooltipPosition="above">
                            {{role.get('rolename').value | slice: 0:40}}...</div>
                        </ng-template>
                        <ng-template #noSliceTitle>
                          <div class="text-bold">{{role.get('rolename').value }}</div>
                        </ng-template>
                      </p>
                    </div>
                  </td>
                </div>

              </div>

            </tr>
          </tbody>
        </table>
      </div>
    </form>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="" class="btn-primary" aria-label="Save" (click)="updateUserDetails()"
      [disabled]='userDetailsForm.invalid || isEmailNotValid ||  shouldDisable()'>{{'users.updateUser.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>





<!-- <div class="main-content-wrapper user-edit-container">
  <div class="content-wrapper"> -->
<!-- <mat-tab-group>
      <mat-tab label="Add New User"> -->
<!-- <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="filter-section">
            <button mat-raised-button (click)='navigateToUsersLanding()'>
              <i class="fa fa-angle-left"></i>
              <span> Back</span>
            </button>
          </div> -->
<!-- <div class="title filter-section">
            <div>User Details</div>
          </div> -->
<!-- <div class="btn-wrapper">
            <button (click)="updateUserDetails()" mat-raised-button color="accent" class="btn-bg-color"
              [disabled]='userDetailsForm.invalid'>Save</button>
          </div>
          <div class="tabs">
            <form [formGroup]="userDetailsForm" novalidate>
              <div class="input-class">
                <label>First name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31" class="form-control" formControlName="firstName">
                <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)" class="alert alert-danger">
                  <div *ngIf="f.firstName.errors?.required"> First name is required. </div>
                  <div *ngIf="f.firstName.errors?.minlength"> Minimum 2 characters required. </div>
                  <div *ngIf="f.firstName.errors?.maxlength">Maximum 30 characters allowed. </div>
                  <div *ngIf="f.firstName.errors?.pattern">Special characters, numbers and blank spaces are not allowed. </div>
                </div>
              </div>
              <div class="input-class">
                <label>Last name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31" class="form-control" formControlName="lastName">
                <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)" class="alert alert-danger">
                  <div *ngIf="f.lastName.errors?.required"> Last name is required. </div>
                  <div *ngIf="f.lastName.errors?.minlength"> Minimum 2 characters required.  </div>
                  <div *ngIf="f.lastName.errors?.maxlength">Maximum 30 characters allowed.</div>
                  <div *ngIf="f.lastName.errors?.pattern">Special characters, numbers and blank spaces not allowed </div>
                </div>
              </div>
              <div class="input-class">
                <label>Phone</label>
                <input type="text" maxlength="25" class="form-control" formControlName="phone" onkeypress='return event.charCode>-48 && event.charCode<=57'>
                <div class="col-md-12" *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" class="alert alert-danger">
                  <div *ngIf="f.phone.errors?.required">Phone is reqired.</div>
                  <div *ngIf="f.phone.errors?.minlength"> Minimum 5 characters required. </div>
                  <div *ngIf="f.phone.errors?.maxlength">Maximum 24 characters allowed.</div>
                  <div *ngIf="f.phone.errors?.pattern?.requiredPattern">Phone is invalid.</div>
                </div>
              </div>
              <div class="input-class">
                <label>Email <span class="red-asterisk">*</span></label>
                <input type="text" maxlength="125" class="form-control" formControlName="emailId">
                <div class="col-md-12" *ngIf="f.emailId.invalid && (f.emailId.touched || f.emailId.dirty)" class="alert alert-danger">
                  <div *ngIf="f.emailId.errors?.required">Email is required.</div>
                  <div *ngIf="f.emailId.errors?.minlength"> Minimum 7 characters required.</div>
                  <div *ngIf="f.emailId.errors?.maxlength">Maximum 124 characters allowed.</div>
                  <div *ngIf="f.emailId.errors?.pattern">Email is invalid.</div>
                </div>
              </div>
              <div class="input-class">
                <label>Status<span class="red-asterisk">*</span></label>
                <select class="form-control" formControlName="status">
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>


            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
